import { Plus, ChevronDown, ChevronUp, Search } from "lucide-react";
import React, { useRef, useState, useEffect } from "react";
import gsap from "gsap";
import { Spiral as Hamburger } from "hamburger-react";
import TaskCards from "./TaskCards";

const Task2 = () => {
    const [drawerOpen, setDrawerOpen] = useState(true);
    const [accordionOpen, setAccordionOpen] = useState(true);
    const [search, setSearch] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [newListName, setNewListName] = useState("");

    const drawerRef = useRef(null);
    const overlayRef = useRef(null);
    const contentRef = useRef(null);
    const popupRef = useRef(null);
    const popupOverlayRef = useRef(null);

    const listItems = [
        "Marketing Leads",
        "Hot Leads",
        "Old Leads",
        "Converted Customers",
        "Follow-up Clients",
    ];

    useEffect(() => {
        if (drawerOpen) {
            gsap.to(drawerRef.current, { x: 0, duration: 0.4, ease: "power3.out" });
            gsap.to(overlayRef.current, { opacity: 1, pointerEvents: "auto", duration: 0.3 });
        } else {
            gsap.to(drawerRef.current, { x: 350, duration: 0.4, ease: "power3.in" });
            gsap.to(overlayRef.current, { opacity: 0, pointerEvents: "none", duration: 0.3 });
        }
    }, [drawerOpen]);

    useEffect(() => {
        if (accordionOpen) {
            gsap.fromTo(
                contentRef.current,
                { height: 0, opacity: 0 },
                { height: "auto", opacity: 1, duration: 0.35, ease: "power2.out" }
            );
        } else {
            gsap.to(contentRef.current, { height: 0, opacity: 0, duration: 0.3, ease: "power2.in" });
        }
    }, [accordionOpen]);

    useEffect(() => {
        if (showPopup) {
            gsap.fromTo(
                popupRef.current,
                { scale: 0.8, opacity: 0 },
                { scale: 1, opacity: 1, duration: 0.3, ease: "power3.out" }
            );
            gsap.to(popupOverlayRef.current, { opacity: 1, pointerEvents: "auto", duration: 0.3 });
        } else {
            gsap.to(popupRef.current, { scale: 0.8, opacity: 0, duration: 0.2, ease: "power3.in" });
            gsap.to(popupOverlayRef.current, { opacity: 0, duration: 0.2 });
        }
    }, [showPopup]);

    const handleCreateList = () => {
        if (!newListName.trim()) return alert("Enter a list name");
        console.log("New List Created:", newListName);
        setNewListName("");
        setShowPopup(false);
    };

    return (
        <>
            <div className="flex items-center justify-between -mt-3">
                <h1 className="dashboard-title">Tasks</h1>
                <span className="cursor-pointer">
                    <Hamburger toggled={drawerOpen} toggle={setDrawerOpen} size={22} />
                </span>
            </div>

            <div className={`transition-all duration-400 ease-in-out ${drawerOpen ? "pr-[250px]" : "pr-0"}`}>
                <TaskCards />
            </div>

            <div
                ref={drawerRef}
                className="fixed top-[48px] right-0 h-[calc(100vh-48px)] w-[250px] bg-white shadow-xl p-3 translate-x-[250px] z-40"
            >
                <h2 className="text-lg font-semibold mb-2">Menu</h2>

                <div className="flex justify-end w-full">
                    <button className="w-full py-2 px-5 text-sm text-center bg-blue-100 rounded-lg text-black font-semibold tracking-wide flex items-center justify-center gap-2 cursor-pointer">
                        <Plus size={18} /> Create Task
                    </button>
                </div>

                <div>
                    <div className="flex justify-between items-center py-3 cursor-pointer" onClick={() => setAccordionOpen(!accordionOpen)}>
                        <h3 className="text-sm font-semibold text-gray-800">Lists</h3>
                        {accordionOpen ? <ChevronUp size={18} className="text-gray-600" /> : <ChevronDown size={18} className="text-gray-600" />}
                    </div>

                    <div ref={contentRef} className="h-0 opacity-0 overflow-hidden border-t">
                        <div className="pt-3 space-y-3">
                            <div className="relative">
                                <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                                <input
                                    type="text"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    placeholder="Search lists..."
                                    className="w-full pl-9 pr-3 py-1.5 border rounded-md text-sm"
                                />
                            </div>

                            <p
                                onClick={() => setShowPopup(true)}
                                className="text-blue-600 text-sm font-medium cursor-pointer hover:underline flex items-center gap-2"
                            >
                                <Plus size={18} /> Create New List
                            </p>

                            {/* Inline Create List Box */}
                            {showPopup && (
                                <div className="mt-3 px-1">
                                    <input
                                        type="text"
                                        value={newListName}
                                        onChange={(e) => setNewListName(e.target.value)}
                                        placeholder="List name"
                                        className="w-full px-3 py-1.5 border outline-0 rounded-md text-sm focus:ring-1 focus:ring-blue-500 mb-3"
                                    />

                                    <div className="flex justify-end gap-2">
                                        <button
                                            onClick={() => {
                                                setShowPopup(false);
                                                setNewListName("");
                                            }}
                                            className="px-3 py-1.5 text-sm rounded-md bg-gray-200 hover:bg-gray-300"
                                        >
                                            Cancel
                                        </button>

                                        <button
                                            onClick={handleCreateList}
                                            className="px-3 py-1.5 text-sm rounded-md bg-blue-600 text-white hover:bg-blue-700"
                                        >
                                            Save
                                        </button>
                                    </div>
                                </div>
                            )}


                            <div className="space-y-2 max-h-40 overflow-y-auto">
                                {listItems
                                    .filter((item) => item.toLowerCase().includes(search.toLowerCase()))
                                    .map((item, index) => (
                                        <label key={index} className="flex items-center gap-2 text-sm cursor-pointer">
                                            <input type="checkbox" defaultChecked className="h-4 w-4 accent-blue-600" />
                                            {item}
                                        </label>
                                    ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default Task2;